export enum UserGroupValue {
  CUSTOMER = "811b7397-72fa-4374-8a98-3d8ad4bac7dd",
  STORE = "1760c0ac-c552-44ac-ab13-c56081d49bb3",
}
